import { itemsPaginationParams as defaultPaginationParams } from '../pages/items/Constants';
import { poisPaginationParams } from '../pages/appCms/poi/Constants';
import {
  RESET_CONDITION_FILTER,
  RESET_ITEM_FILTER,
  RESET_MOVEMENT_FILTER,
  RESET_TREATMENT_FILTER,
  RESET_POI_FILTER,
  // RESET_BEACON_FILTER,
  // RESET_NEWS_FILTER,
  SET_CONDITION_AS_FILTERED,
  SET_ITEM_AS_FILTERED,
  SET_ITEM_SEARCH_AS_ADVANCED,
  SET_MOVEMENT_AS_FILTERED,
  SET_TREATMENT_AS_FILTERED,
  SET_POI_AS_FILTERED,
  SET_POI_SEARCH_AS_ADVANCED,
  // SET_BEACON_AS_FILTERED,
  // SET_BEACON_SEARCH_AS_ADVANCED,
  // SET_NEWS_AS_FILTERED,
  // SET_NEWS_SEARCH_AS_ADVANCED,
  UPDATE_CONDITION_FILTER,
  UPDATE_ITEM_FILTER,
  UPDATE_MOVEMENT_FILTER,
  UPDATE_TREATMENT_FILTER,
  UPDATE_POI_FILTER,
  // UPDATE_BEACON_FILTER,
  // UPDATE_NEWS_FILTER,
} from './types';

const INITIAL_STATE = {
  itemFilterParams: { ...defaultPaginationParams },
  isItemFiltered: false,
  isItemSearchAdvanced: false,
  conditionFilterParams: { ...defaultPaginationParams },
  isConditionFiltered: false,
  treatmentFilterParams: { ...defaultPaginationParams },
  isTreatmentFiltered: false,
  movementFilterParams: { ...defaultPaginationParams },
  isMovementFiltered: false,
  poiFilterParams: { ...poisPaginationParams },
  isPoiFiltered: false,
  isPoiSearchAdvanced: false,
  newsFilterParams: { ...defaultPaginationParams },
  isNewsFiltered: false,
  isNewsSearchAdvanced: false,
  beaconFilterParams: { ...defaultPaginationParams },
  isBeaconFiltered: false,
  isBeaconSearchAdvanced: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_ITEM_FILTER:
      return {
        ...state,
        itemFilterParams: action.payload,
      };
    case RESET_ITEM_FILTER:
      return {
        ...state,
        itemFilterParams: { ...defaultPaginationParams },
        isItemFiltered: false,
        isItemSearchAdvanced: false,
      };
    case SET_ITEM_AS_FILTERED:
      return {
        ...state,
        isItemFiltered: action.payload,
      };
    case SET_ITEM_SEARCH_AS_ADVANCED:
      return {
        ...state,
        isItemSearchAdvanced: action.payload,
      };
    case UPDATE_POI_FILTER:
      return {
        ...state,
        poiFilterParams: action.payload,
      };
    case RESET_POI_FILTER:
      return {
        ...state,
        poiFilterParams: { ...poisPaginationParams },
        isPoiFiltered: false,
        isPoiSearchAdvanced: false,
      };
    case SET_POI_AS_FILTERED:
      return {
        ...state,
        isPoiFiltered: action.payload,
      };
    case SET_POI_SEARCH_AS_ADVANCED:
      return {
        ...state,
        isPoiSearchAdvanced: action.payload,
      };
    //   case UPDATE_BEACON_FILTER:
    //     return {
    //       ...state,
    //       beaconFilterParams: action.payload,
    //     };
    //   case RESET_BEACON_FILTER:
    //     return {
    //       ...state,
    //       beaconFilterParams: { ...defaultPaginationParams },
    //       isBeaconFiltered: false,
    //       isBeaconSearchAdvanced: false,
    //     };
    //   case SET_BEACON_AS_FILTERED:
    //     return {
    //       ...state,
    //       isBeaconFiltered: action.payload,
    //     };
    //   case SET_BEACON_SEARCH_AS_ADVANCED:
    //     return {
    //       ...state,
    //       isBeaconSearchAdvanced: action.payload,
    //     };
    //    case UPDATE_NEWS_FILTER:
    //   return {
    //     ...state,
    //     newsFilterParams: action.payload,
    //   };
    // case RESET_NEWS_FILTER:
    //   return {
    //     ...state,
    //     newsFilterParams: { ...defaultPaginationParams },
    //     isNewsFiltered: false,
    //     isNewsSearchAdvanced: false,
    //   };
    // case SET_NEWS_AS_FILTERED:
    //   return {
    //     ...state,
    //     isNewsFiltered: action.payload,
    //   };
    // case SET_NEWS_SEARCH_AS_ADVANCED:
    //   return {
    //     ...state,
    //     isNewsSearchAdvanced: action.payload,
    //   };
    case UPDATE_CONDITION_FILTER:
      return {
        ...state,
        conditionFilterParams: action.payload,
      };
    case RESET_CONDITION_FILTER:
      return {
        ...state,
        conditionFilterParams: { ...defaultPaginationParams },
        isConditionFiltered: false,
      };
    case SET_CONDITION_AS_FILTERED:
      return {
        ...state,
        isConditionFiltered: action.payload,
      };
    case UPDATE_TREATMENT_FILTER:
      return {
        ...state,
        treatmentFilterParams: action.payload,
      };
    case RESET_TREATMENT_FILTER:
      return {
        ...state,
        treatmentFilterParams: { ...defaultPaginationParams },
        isTreatmentFiltered: false,
      };
    case SET_TREATMENT_AS_FILTERED:
      return {
        ...state,
        isTreatmentFiltered: action.payload,
      };
    case UPDATE_MOVEMENT_FILTER:
      return {
        ...state,
        movementFilterParams: action.payload,
      };
    case RESET_MOVEMENT_FILTER:
      return {
        ...state,
        movementFilterParams: { ...defaultPaginationParams },
        isMovementFiltered: false,
      };
    case SET_MOVEMENT_AS_FILTERED:
      return {
        ...state,
        isMovementFiltered: action.payload,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
